/* eslint-disable import/prefer-default-export */
export const createWay = {
  NORMAL: 1,
  UNPAID: 2,
  // 拼团-开团
  ACTIVITY_GROUP_NEW: 3,
  // 拼团-参团
  ACTIVITY_GROUP_JOIN: 4,
}
